import type { JSX } from 'react';
import { Box } from '@mui/material';

export default function AllocationLineItemsDialogMessage({
  message,
}: {
  message: string;
}): JSX.Element {
  return (
    <Box sx={{ color: 'error.main', mt: 2, textAlign: 'right' }}>{message}</Box>
  );
}
